import apiSlice from "./ApiSlice";

const subjectApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllSubjectData: builder.query({
      providesTags: ["subject"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/subject",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteSubjectById: builder.mutation({
      invalidatesTags: ["subject"],
      query: (id: any) => ({
        url: `/subject/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addSubject: builder.mutation({
      invalidatesTags: ["subject"],
      query: (body) => ({
        url: `/subject/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getSubjectById: builder.query({
      providesTags: ["subject"],
      query: (id: string) => {
        return {
          url: `/subject/${id}`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateSubjectById: builder.mutation({
      invalidatesTags: ["subject"],
      query: ({ body, id }) => ({
        url: `/subject/${id}`,
        method: "PUT",
        body,
      }),
    }),



    //get Subjects
    getAllSubjects: builder.query({
      providesTags: ["subject"],
      query: () => {
        return {
          url: `/subject`,
          method: "GET",
        };
      },
    }),


    // change status of delivery date
    changeStatusSubjectById: builder.mutation({
      invalidatesTags: ["subject"],
      query: ({ body, id }) => ({
        url: `/subject/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllSubjectDataQuery,
  useDeleteSubjectByIdMutation,
  useAddSubjectMutation,
  useGetSubjectByIdQuery,
  useGetAllSubjectsQuery,
  useUpdateSubjectByIdMutation,
  useChangeStatusSubjectByIdMutation,
} = subjectApi;
